const dataAggregationTypes = {
  'max': {
    text: 'Max',
    value: 'max',
  },
  'min': {
    text: 'Min',
    value: 'min',
  },
  'mean': {
    text: 'Mean',
    value: 'mean',
  },
  'median': {
    text: 'Median',
    value: 'median',
  },
  'standard-deviation': {
    text: 'Standard Deviation',
    value: 'standard-deviation',
  },
  'standard-error': {
    text: 'Standard Error',
    value: 'standard-error',
  },
}

export {
  dataAggregationTypes,
}